import React from 'react';
import Button from '../../UI/Button/Button';
import styles from './AmenitiesBtn.module.scss';

const AmenitiesBtn = ({ onClick, _amenitiesLength }) => (
  <Button
    onClick={onClick}
    classes={`${styles.amenitiesBtn} btn flex flex-center t-500`}
    type="button"
  >
    <span className="btn__text">
      See other
    </span>
  </Button>
);

export default AmenitiesBtn;
